import CalculatorSimpleForm from './CalculatorSimpleForm'

export default CalculatorSimpleForm
